<mat-sidenav-container class="client-container">
  <mat-sidenav
    style="width: 50%; overflow-x: hidden !important"
    #sidenav
    mode="over"
    class="main create-mail"
    position="end"
    [opened]="openCreateMailSheetValue"
    disableClose
  >
    <div>
      <form [formGroup]="mailForm">
        <div class="sliding-sheet-header">
          <h4>Compose Mail</h4>
          <button type="button" (click)="closeCreateMailSheet()"><mat-icon>close</mat-icon></button>
        </div>

        <div class="row" [hidden]="isShowUpdateClientSection">
          <div class="col-md-12 mt-2">
            <div class="subject">
              To :
              <mat-form-field
                *ngIf="
                  mailSheetContext?.source == 'past-clients' || mailSheetContext?.source == 'expired-listings';
                  else showEmail
                "
                class="pl-2 sub-input"
              >
                <input
                  [disabled]="isMailDisabled"
                  matInput
                  formControlName="toEmail"
                  placeholder="Email address"
                  autocomplete="off"
                />
              </mat-form-field>
              <button *ngIf="selectedEmail" class="clear-btn" type="button" (click)="removeSelected('email')">×</button>
              <div>
                <span class="email-chip" *ngFor="let item of visibleEmails" (click)="selected(item, 'email')">
                  {{ item.email }}
                </span>
              </div>

              <ng-template #showEmail>
                <b>{{ clientDetails.email }}</b>
              </ng-template>
            </div>

            <div
              class="subject"
              *ngIf="mailSheetContext?.source == 'past-clients' || mailSheetContext?.source == 'expired-listings'"
            >
              Name :
              <mat-form-field class="pl-2 sub-input">
                <input
                  [disabled]="isMailDisabled"
                  matInput
                  formControlName="toName"
                  placeholder="Name"
                  autocomplete="off"
                />
              </mat-form-field>
              <button *ngIf="selectedName" class="clear-btn" type="button" (click)="removeSelected('name')">×</button>
              <div>
                <span class="email-chip" *ngFor="let item of visibleName" (click)="selected(item, 'name')">
                  {{ item.name }}
                </span>
              </div>
            </div>

            <p class="subject">
              Subject :
              <mat-form-field style="" class="pl-2 sub-input">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" autocomplete="off" />
                <mat-error
                  *ngIf="mailFormControls.subject.errors && !mailFormControls.subject.errors.message"
                  class="invalid-feedback"
                >
                  Subject is required</mat-error
                >
              </mat-form-field>
              <mat-error *ngIf="mailFormControls?.subject?.errors?.message" class="invalid-feedback">
                Subject is required
              </mat-error>
            </p>

            <div class="px-4 py-2">
              <angular-editor formControlName="content" required [config]="config" name="content"></angular-editor>
              <mat-error *ngIf="mailFormControls?.content?.errors" class="invalid-feedback">
                Content is required
              </mat-error>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </form>
    </div>

    <div class="px-4 py-2" [hidden]="!isShowUpdateClientSection">
      <div class="row">
        <div class="col-md-12">
          <h5 class="pl-3 mt-3">
            {{
              mailSheetContext?.source == 'expired-listings'
                ? 'Do you really want to update the owner details?'
                : 'Do you really want to update the client details?'
            }}
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-6 col-12 mt-3">
          <mat-form-field class="col-lg-12" appearance="outline">
            <mat-label> List Name</mat-label>
            <mat-select (selectionChange)="updateClientDetails($event.value)">
              <mat-option *ngFor="let opt of pastClientOption" [value]="opt">{{ opt.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="ml-3 mb-5" style="float: left">
        <button class="my-2" type="button" color="primary" mat-flat-button (click)="update()">Update</button>
        <button
          class="ml-2"
          type="button"
          color="primary"
          mat-button
          (click)="cancel()"
          [pmx-progress-button]="sendingMailInProgress"
        >
          cancel
        </button>
      </div>
    </div>

    <div class="row px-4 py-2" [hidden]="isShowUpdateClientSection">
      <div class="col-sm-12 col-md-12 col-12">
        <h4 class="mb-0 sec-head">
          <span class="mt-1">Attachments</span>
          <app-multi-file-upload (attachments)="getAttachments($event)" class=""></app-multi-file-upload>
        </h4>
      </div>
    </div>

    <div
      class="row px-4 py-4"
      [hidden]="
        isShowUpdateClientSection ||
        mailSheetContext?.source == 'past-clients' ||
        mailSheetContext?.source == 'expired-listings'
      "
    >
      <div class="col-sm-12 col-md-12 col-12">
        <h4 class="mb-0 sec-head">
          <span class="mt-1">Search Properties</span>
        </h4>
        <div>
          <div class="search_base" style="display: flex; margin-top: 15px">
            <input
              type="text"
              class="form-control"
              #searchField
              [(ngModel)]="autoCompleteInput"
              (addressComponents)="getAddressComponents($event)"
              placeholder="Find Property"
              name="autocompleteInput"
              required
              name="search property"
              tabindex="2"
              aria-label="enter address"
              googleAutocomplete
            />
            <button
              mat-mini-fab
              color="primary"
              type="input"
              (click)="addProperty()"
              [ngClass]="{ goActive: autoCompleteInput }"
              name="initiate search"
              class="show"
              aria-label="search address"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-sm-6 col-12" *ngFor="let property of propertyAttachments; let i = index">
            <div style="width: 100% !important" class="property-card">
              <button type="button" mat-flat-button class="follow-btn cls-btn" (click)="removeSelectedProperty(i)">
                <img src="../../../../assets/images/close.png" />
              </button>
              <app-property-card [detailsRequired]="detailsRequired" [property]="property"></app-property-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ml-4 mb-5" style="float: left" [hidden]="isShowUpdateClientSection">
      <button
        class="my-2"
        type="button"
        color="primary"
        mat-flat-button
        (click)="sendMail()"
        [pmx-progress-button]="sendingMailInProgress"
      >
        Send Mail
      </button>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
